const accordionItem = document.querySelectorAll('.accordion__btn');

accordionItem.forEach((item) => {
  item.addEventListener('click', (e) => {
    const target = e.target;
    const parent = e.target.parentElement;
    target.classList.toggle('accordion__btn--open');
    const text = parent.querySelector('.accordion__body');

    if (text.style.maxHeight) {
      text.style.maxHeight = null;
      text.style.opacity = '0';
    } else {
      text.style.maxHeight = text.scrollHeight + "px";
      text.style.opacity = '1';
    }
  })
});